import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "landingBg mb-landing-sm md:mb-landing-md bg-bp",
  style: {"background-position":"0px -10px","margin-top":"-80px","padding-top":"76px","position":"inherit"}
}
const _hoisted_2 = {
  class: "leading-normal tracking-normal text-white dark:text-gray-300 gradient",
  style: {"font-family":"'Nunito', sans-serif"}
}
const _hoisted_3 = { class: "justify-center text-center items-center md:items-start pt-2" }
const _hoisted_4 = {
  id: "Boost your Day",
  class: "max-w-4xl mx-auto my-4 mt-0 text-4xl sm:text-4xl font-bold leading-tight text-bp text",
  "data-aos": "zoom-in",
  "data-aos-anchor": "#search"
}
const _hoisted_5 = {
  id: "searchBar",
  class: "max-w-4xl mx-auto",
  "data-aos": "zoom-in",
  "data-aos-anchor": "#searchBar"
}
const _hoisted_6 = { class: "grid sm:grid-cols-4 gap-4 mx-auto text-center" }
const _hoisted_7 = {
  id: "Explore",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#Explore"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Explore.png"
}, null, -1)
const _hoisted_9 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_10 = { class: "bp-font-text" }
const _hoisted_11 = {
  id: "explaindetail2",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#explaindetail2"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Choose.png"
}, null, -1)
const _hoisted_13 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_14 = { class: "bp-font-text" }
const _hoisted_15 = {
  id: "explaindetail3",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#explaindetail3"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Subscribe1.png"
}, null, -1)
const _hoisted_17 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_18 = { class: "bp-font-text" }
const _hoisted_19 = {
  id: "explaindetail4",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#explaindetail4"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Boost2.png"
}, null, -1)
const _hoisted_21 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_22 = { class: "bp-font-text" }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = {
  id: "explaintext",
  class: "w-full mt-1 -mb-2 text-4xl font-bold bp-font text-center",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#explaintext"
}
const _hoisted_25 = { class: "w-full mt-4 mb-4 text-4xl font-bold bp-font text-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "grid sm:grid-cols-2 justify-center" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://apps.apple.com/at/app/boostpack/id1620312288?l=en",
    class: "sm:justify-self-end"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "download on the App Store",
      class: "justify-end w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/apple-app-store-badge.svg"
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "https://play.google.com/store/apps/details?id=app.boostpack.twa" }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Get it on Google Play",
      class: "justify-start w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/google-play-badge.svg"
    })
  ])
], -1)
const _hoisted_27 = { class: "w-full mt-4 mb-4 text-4xl font-bold bp-font text-center" }
const _hoisted_28 = { class: "grid sm:grid-cols-3 gap-4 mx-auto text-center" }
const _hoisted_29 = {
  id: "ReasonTitle1",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#ReasonTitle1"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Boost1.png"
}, null, -1)
const _hoisted_31 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_32 = { class: "bp-font-text" }
const _hoisted_33 = {
  id: "ReasonTitle2",
  class: "sm:hidden",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#ReasonTitle2"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Subscribe1.png"
}, null, -1)
const _hoisted_35 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_36 = { class: "bp-font-text" }
const _hoisted_37 = {
  id: "ReasonTitle2Desktop",
  class: "hidden sm:block",
  "data-aos": "zoom-in-down",
  "data-aos-anchor": "#ReasonTitle2Desktop"
}
const _hoisted_38 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_39 = { class: "bp-font-text" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Subscribe1.png"
}, null, -1)
const _hoisted_41 = {
  id: "ReasonTitle3",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#ReasonTitle3"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "mx-auto mt-4 mb-4 w-40 h-40",
  src: "/img/landing/Duration.png"
}, null, -1)
const _hoisted_43 = { class: "bp-font-text text-4xl mb-2 break-all" }
const _hoisted_44 = { class: "bp-font-text" }
const _hoisted_45 = { class: "w-full mt-4 mb-4 text-4xl font-bold bp-font text-center" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "grid sm:grid-cols-2 justify-center" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://apps.apple.com/at/app/boostpack/id1620312288?l=en",
    class: "sm:justify-self-end"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "download on the App Store",
      class: "justify-end w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/apple-app-store-badge.svg"
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "https://play.google.com/store/apps/details?id=app.boostpack.twa" }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Get it on Google Play",
      class: "justify-start w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/google-play-badge.svg"
    })
  ])
], -1)
const _hoisted_47 = { class: "w-full mt-4 mb-4 text-4xl font-bold bp-font text-center" }
const _hoisted_48 = {
  id: "LandingTalk",
  "data-aos": "zoom-in-up",
  "data-aos-anchor": "#LandingTalk"
}
const _hoisted_49 = { class: "bp-font-text text-xl font-bold text-center pb-4" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "sm:max-w-sm mx-auto p-4",
  src: "/img/landing/LandingTalk.webp"
}, null, -1)
const _hoisted_51 = { class: "bp-font-text text-xl font-bold text-center pt-4 pb-4" }
const _hoisted_52 = { class: "pb-6" }
const _hoisted_53 = { class: "w-full mt-4 mb-4 text-4xl font-bold bp-font text-center" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "grid sm:grid-cols-2 justify-center" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://apps.apple.com/at/app/boostpack/id1620312288?l=en",
    class: "sm:justify-self-end"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "download on the App Store",
      class: "justify-end w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/apple-app-store-badge.svg"
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "https://play.google.com/store/apps/details?id=app.boostpack.twa" }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Get it on Google Play",
      class: "justify-start w-52 sm:h-16 m-2 sm:my-0",
      src: "/img/landing/appStore/google-play-badge.svg"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search = _resolveComponent("search")
  const _component_default_card_layout = _resolveComponent("default-card-layout")
  const _component_DefaultRedirectButton = _resolveComponent("DefaultRedirectButton")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("body", _hoisted_2, [
      _createVNode(_component_default_card_layout, {
        "card-bg": "",
        class: "rounded-3xl md:mx-5 lg:w-3/4 lg:mx-auto m-4 backdrop-filter backdrop-blur-xl"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("landing.Landing.LandingTitle")), 1),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_search, {
                  "search-placeholder": _ctx.$t('landing.Landing.LandingSearch'),
                  onRedirectSearch: $setup.redirectFeed
                }, null, 8, ["search-placeholder", "onRedirectSearch"])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { class: "relative z-10 md:mx-5 lg:w-3/4 lg:mx-auto m-4" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t("landing.Landing.ExplainTitle1")), 1),
              _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("landing.Landing.ExplainDetail1")), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t("landing.Landing.ExplainTitle2")), 1),
              _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("landing.Landing.ExplainDetail2")), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t("landing.Landing.ExplainTitle3")), 1),
              _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("landing.Landing.ExplainDetail3")), 1)
            ]),
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("h1", _hoisted_21, _toDisplayString(_ctx.$t("landing.Landing.ExplainTitle4")), 1),
              _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("landing.Landing.ExplainDetail4")), 1)
            ])
          ]),
          _hoisted_23,
          _createVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t("landing.Landing.LandingStart")), 1),
          _createVNode(_component_DefaultRedirectButton, {
            id: "explainbutton",
            "button-text": _ctx.$t('landing.Landing.LandingSearchBtn'),
            "button-width": "auto",
            "css-class": "animate__animated animate__fadeInUp  item-end text-center",
            "data-aos": "zoom-in-up",
            "data-aos-anchor": "#explainbutton",
            link: "/feed"
          }, null, 8, ["button-text"])
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, {
        "card-bg": "",
        id: "PreviewApp",
        class: "md:mx-5 lg:w-3/4 xl:-mx-auto lg:mx-auto m-4 relative",
        "data-aos": "zoom-in-up",
        "data-aos-anchor": "#PreviewApp",
        style: {"z-index":"1"}
      }, {
        default: _withCtx(() => [
          _createVNode("h1", _hoisted_25, _toDisplayString(_ctx.$t("landing.Landing.LandingAppTitle")), 1),
          _hoisted_26
        ]),
        _: 1
      }),
      _createVNode("section", null, [
        _createVNode(_component_DefaultCardLayout, { class: "md:mx-5 lg:w-3/4 lg:mx-auto m-4" }, {
          default: _withCtx(() => [
            _createVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonTitle")), 1),
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode("h1", _hoisted_31, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonTitle1")), 1),
                _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonDetail1")), 1)
              ]),
              _createVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode("h1", _hoisted_35, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonTitle2")), 1),
                _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonDetail2")), 1)
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("h1", _hoisted_38, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonTitle2")), 1),
                _createVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonDetail2")), 1),
                _hoisted_40
              ]),
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode("h1", _hoisted_43, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonTitle3")), 1),
                _createVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("landing.Landing.LandingReasonDetail3")), 1)
              ])
            ]),
            _createVNode(_component_DefaultRedirectButton, {
              id: "ReasonButton",
              "button-text": _ctx.$t('landing.Landing.LandingReasonBtn'),
              "button-width": "auto",
              "css-class": "animate__animated animate__fadeInUp item-end text-center",
              "data-aos": "zoom-in-up",
              "data-aos-anchor": "#ReasonButton",
              link: "/feed"
            }, null, 8, ["button-text"])
          ]),
          _: 1
        }),
        _createVNode(_component_DefaultCardLayout, {
          "card-bg": "",
          id: "PreviewApp",
          class: "md:mx-5 lg:w-3/4 xl:-mx-auto lg:mx-auto m-4 relative",
          "data-aos": "zoom-in-up",
          "data-aos-anchor": "#PreviewApp",
          style: {"z-index":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode("h1", _hoisted_45, _toDisplayString(_ctx.$t("landing.Landing.LandingAppTitle")), 1),
            _hoisted_46
          ]),
          _: 1
        }),
        _createVNode(_component_DefaultCardLayout, {
          id: "Reason",
          class: "md:mx-5 lg:w-3/4 xl:-mx-auto lg:mx-auto m-4",
          "data-aos": "zoom-in-up",
          "data-aos-anchor": "#Reason"
        }, {
          default: _withCtx(() => [
            _createVNode("h1", _hoisted_47, _toDisplayString(_ctx.$t("landing.Landing.LandingTalk")), 1),
            _createVNode("div", _hoisted_48, [
              _createVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("landing.Landing.LandingTalkDetail")), 1),
              _hoisted_50,
              _createVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("landing.Landing.LandingTalkDetail2")), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("section", _hoisted_52, [
        _createVNode(_component_DefaultCardLayout, {
          "card-bg": "",
          id: "PreviewApp",
          class: "mb-landing-b-sm md:mb-landing-b-md md:mx-5 lg:w-3/4 xl:-mx-auto lg:mx-auto m-4 relative ",
          "data-aos": "zoom-in-up",
          "data-aos-anchor": "#PreviewApp",
          style: {"z-index":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode("h1", _hoisted_53, _toDisplayString(_ctx.$t("landing.Landing.LandingAppTitle")), 1),
            _hoisted_54
          ]),
          _: 1
        })
      ])
    ])
  ]))
}